export enum PropertyInvestmentStep {
  EOI = 1,
  PAS4 = 2,
  REGESTRATION = 3,
  DASHBOARD = 4,
}
